import "../assets/styles/desktop.scss";
import { ReactComponent as AppleStoreLogo } from "../assets/images/apple_store.svg";
import { ReactComponent as GooglePlayLogo } from "../assets/images/google_play.svg";

export default function DesktopPcOnlyPage() {
  return (
    <section className="container">
      <p>
        <span>🐾 야옹상회 이용 및 송추 히든밸리 수영장 예약은 앱에서만 이용할 수 있어요!</span>
      </p>
      <p>수영장 평상 예약하고 더 많은 고양이 친구들이 주는 포인트 보상을 만나려면</p>
      <p>
        <span>지금 야옹상회 앱을 설치해보세요!</span>
      </p>
      <p>
        <span>앱 전용 서비스 안내</span>
      </p>
      <p>• 송추 히든밸리 수영장 평상 예약도 앱에서만 제공돼요.</p>
      <p>•출석체크, 럭키스핀, 토리를 구해줘 미니게임, 에그 부화 미니게임,</p>
      <p>
        도감 수집, 간식 타이밍 맞추기 등 모든 기능은 <span>앱에서만 제공돼요.</span>
      </p>
      <p>•웹에서는 더 이상 야옹상회를 이용하실 수 없어요 😿 </p>
      <p className="font-big">📱 아래 버튼을 눌러 앱을 다운로드해 주세요!</p>
      <div className="buttons">
        <div className="btn_container">
          <a
            href="#"
            onClick={() => {
              window.location.href = "https://play.google.com/store/apps/details?id=com.yaong.app";
            }}
          >
            <GooglePlayLogo />
          </a>
          <a
            href="#"
            onClick={() => {
              window.location.href =
                "https://apps.apple.com/kr/app/%EC%95%BC%EC%98%B9%EC%83%81%ED%9A%8C-%EC%89%BD%EA%B3%A0-%EC%A6%90%EA%B1%B0%EC%9A%B4-%ED%8F%AC%EC%9D%B8%ED%8A%B8-%EB%A6%AC%EC%9B%8C%EB%93%9C%EC%95%B1-%EC%95%B1%ED%85%8C%ED%81%AC/id6502283766";
            }}
          >
            <AppleStoreLogo />
          </a>
        </div>
      </div>
    </section>
  );
}
